import React from "react";
import Select from "react-select";

/** react-select styling aligned to the builder's native controls. */
const SELECT_STYLES = {
  control: (base) => ({
    ...base,
    minHeight: 38,
    borderColor: "#cbd5e1",
    borderRadius: 8,
    fontSize: 14,
    boxShadow: "none",
    ":hover": { borderColor: "#cbd5e1" },
  }),
  valueContainer: (base) => ({ ...base, padding: "1px 8px" }),
  menu: (base) => ({ ...base, zIndex: 20, fontSize: 14 }),
  placeholder: (base) => ({ ...base, color: "#64748b" }),
};

/**
 * Location scope for the Query Builder, shown first so a query is narrowed to
 * the chosen locations before a dataset is picked. An empty selection means all
 * locations. The value is the location id, which the dataset scopes on (the
 * stored location name is a long address that wouldn't match a friendly label).
 * @param {object} props
 * @param {Array<{value: number, label: string}>} props.options the location choices.
 * @param {number[]} props.value the selected location ids.
 * @param {(ids: number[]) => void} props.onChange sets the selected location ids.
 * @returns {JSX.Element}
 */
export default function LocationScopeSelector({ options, value, onChange }) {
  const selected = options.filter((opt) => value.includes(opt.value));
  return (
    <div className="qb-field">
      <span className="qb-label">Location</span>
      <Select
        isMulti
        className="qb-location-select"
        classNamePrefix="qb-locsel"
        styles={SELECT_STYLES}
        options={options}
        value={selected}
        onChange={(picked) =>
          onChange((picked ?? []).map((opt) => opt.value))
        }
        placeholder="All locations"
        aria-label="Scope by location"
        closeMenuOnSelect={false}
        noOptionsMessage={() => "No locations"}
      />
    </div>
  );
}
